import { put, takeLatest, select, call } from "redux-saga/effects"

import { toast } from "react-toastify"

import {
  GET_SCHOOL_DATA_SUCCESSFUL,
  GET_FORUMS_SUCCESSFUL,
  GET_FORUMS_UNANSWERED_SUCCESSFUL,
  SUBMIT_FORUM_QUESTION_SUCCESSFUL,
  SUBMIT_FORUM_QUESTION_FAILED,
  SUBMIT_FORUM_ANSWER_SUCCESSFUL,
  SUBMIT_FORUM_ANSWER_FAILED,
  SUBMIT_FORUM_COMMENT_SUCCESSFUL,
  SUBMIT_FORUM_COMMENT_FAILED,
  UPVOTE_FORUM_ANSWER_SUCCESSFUL,
  DOWNVOTE_FORUM_ANSWER_SUCCESSFUL,
  UPVOTE_FORUM_QUESTION_SUCCESSFUL,
  DOWNVOTE_FORUM_QUESTION_SUCCESSFUL,
  UPDATE_FORUM_QUESTION_SUCCESSFUL,
  UPDATE_FORUM_ANSWER_SUCCESSFUL,
  UPDATE_FORUM_COMMENT_SUCCESSFUL,
  SEARCH_FORUMS_SUCCESSFUL,
  SEARCH_FORUMS_TAG_SUCCESSFUL,
  ACCEPT_FORUM_ANSWER_SUCCESSFUL,
  CLOSE_FORUM_QUESTION_SUCCESSFUL,
  GET_SCHOOL_DATA_BY_DOMAIN_SUCCESSFUL,
  GET_SCHOOL_DATA_BY_DOMAIN_FAILED,
  GET_QUESTION_DATA_FAILED,
  ADD_ANSWER_COMMENT_SUCCESSFUL,
  ADD_ANSWER_COMMENT_FAILED,
  EDIT_ANSWER_COMMENT_SUCCESSFUL,
  EDIT_ANSWER_COMMENT_FAILED,
} from "./action-types"

import history from "app/history"

import {
  getSocials,
  setForumsData,
  setForumsUnansweredData,
  getQuestionById,
  closeForumModal,
  setForumsError,
  setForumAnswerList,
  setForumCommentList,
  setForumLatestList,
  setForumUnansweredList,
} from "store/school/actions"

import { closeConfirmModal } from "store/user/actions"

import { ERROR_500 } from "constants/message"

function* watchGetSchoolDataSuccess() {
  yield takeLatest(
    [GET_SCHOOL_DATA_SUCCESSFUL, GET_SCHOOL_DATA_BY_DOMAIN_SUCCESSFUL],
    function* handleLoginSuccess({ payload }) {
      let schoolData = yield select((state) => state.schoolReducer.schoolData)

      const {
        data: { primary_color },
      } = payload

      yield localStorage.setItem("app-theme", primary_color)
      yield put(getSocials({ schoolId: schoolData.id }))
    }
  )
}

function* watchGetSchoolDataByDomainFailed() {
  yield takeLatest(
    GET_SCHOOL_DATA_BY_DOMAIN_FAILED,
    function* handlegetSchoolDataByDomainFailed() {
      yield put(history.push("/error-404"))
    }
  )
}

function* watchGetSchoolForums() {
  yield takeLatest(GET_FORUMS_SUCCESSFUL, function* handleGetSchoolForums({
    payload,
  }) {
    const { data } = payload
    let forum = yield select((state) => state.schoolReducer.forums)

    let newForum = { ...data }

    if (data.meta.page > 1) {
      newForum.data = forum.data.concat(data.data)
    }
    yield put(setForumsData(newForum))
  })
}

function* watchGetSchoolForumsUnanswered() {
  yield takeLatest(
    GET_FORUMS_UNANSWERED_SUCCESSFUL,
    function* handleGetSchoolForumsUnanswered({ payload }) {
      const { data } = payload
      let forum = yield select((state) => state.schoolReducer.forumsUnanswered)

      let newForum = { ...data }

      if (data.meta.page > 1) {
        newForum.data = forum.data.concat(data.data)
      }
      yield put(setForumsUnansweredData(newForum))
    }
  )
}

function* watchGetSchoolForumsTag() {
  yield takeLatest(
    [SEARCH_FORUMS_SUCCESSFUL, SEARCH_FORUMS_TAG_SUCCESSFUL],
    function* handleGetSchoolForums({ payload }) {
      const { data } = payload
      let forum = yield select((state) => state.schoolReducer.forums)

      let newForum = { ...data }

      if (data.meta.page > 1) {
        newForum.data = forum.data.concat(data.data)
      }

      yield put(setForumsData(newForum))
    }
  )
}

function* watchSubmitQuestionSuccess() {
  yield takeLatest(
    SUBMIT_FORUM_QUESTION_SUCCESSFUL,
    function* handleSubmitQuestionSuccess({ payload }) {
      const { data } = payload

      yield put(closeForumModal())

      yield call(() => history.push(`/forums/topic/${data.id}`))

      toast.success("Question submitted!")
    }
  )
}

function* watchSubmitAnswerSuccess() {
  yield takeLatest(
    SUBMIT_FORUM_ANSWER_SUCCESSFUL,
    function* handleSubmitAnswerSuccess() {
      let questionData = yield select(
        (state) => state.schoolReducer.questionData
      )

      yield put(closeForumModal())
      yield put(getQuestionById(questionData.id))

      toast.success("Answer submitted!")
    }
  )
}

function* watchSubmitCommentSuccess() {
  yield takeLatest(
    [
      SUBMIT_FORUM_COMMENT_SUCCESSFUL,
      ADD_ANSWER_COMMENT_SUCCESSFUL,
      EDIT_ANSWER_COMMENT_SUCCESSFUL,
    ],
    function* handleSubmitCommentSuccess({ payload }) {
      const { config } = payload
      let questionData = yield select(
        (state) => state.schoolReducer.questionData
      )

      yield put(closeForumModal())
      yield put(getQuestionById(questionData.id))

      toast.success(
        config.method === "patch" ? "Comment updated!" : "Comment posted!"
      )
    }
  )
}

function* watchFetchQuestionDataFailed() {
  yield takeLatest(
    GET_QUESTION_DATA_FAILED,
    function* handleFetchQuestionDataFailed({ error }) {
      yield history.push("/forums")
      toast.error("Requested forum question isn't available")
    }
  )
}

function* watchForumSubmitFailed() {
  yield takeLatest(
    [
      SUBMIT_FORUM_QUESTION_FAILED,
      SUBMIT_FORUM_ANSWER_FAILED,
      SUBMIT_FORUM_COMMENT_FAILED,
      ADD_ANSWER_COMMENT_FAILED,
      EDIT_ANSWER_COMMENT_FAILED,
    ],
    function* handleForumSubmitSuccess({ error }) {
      const { status, data } = error.response

      if (status === 500) {
        yield put(setForumsError(ERROR_500))
      } else {
        yield put(setForumsError(data))
      }
    }
  )
}

function* watchUpvoteDownvoteForumAnswerSuccess() {
  yield takeLatest(
    [UPVOTE_FORUM_ANSWER_SUCCESSFUL, DOWNVOTE_FORUM_ANSWER_SUCCESSFUL],
    function* handleUpvoteDownvoteForumAnswerSuccess({ payload }) {
      const { data = {} } = payload

      const { answers = [] } = yield select(
        (state) => state.schoolReducer.questionData
      )

      if (data && data.id) {
        let updatedAnswers = answers.map((item) => {
          if (item.id !== data.id) {
            return item
          }

          return {
            ...item,
            ...data,
          }
        })

        yield put(setForumAnswerList(updatedAnswers))
      }
    }
  )
}

function* watchAcceptForumAnswerSuccess() {
  yield takeLatest(
    ACCEPT_FORUM_ANSWER_SUCCESSFUL,
    function* handleAcceptForumAnswerSuccess({ payload, meta }) {
      const { answers = [] } = yield select(
        (state) => state.schoolReducer.questionData
      )
      const {
        previousAction: { payload: prevPayload = {} },
      } = meta
      const { answerId } = prevPayload

      if (answerId) {
        let updatedAnswers = answers.map((item) => {
          if (item.id !== answerId) {
            item.answer = false
            return item
          }

          return {
            ...item,
            answer: !item.answer,
          }
        })

        yield put(setForumAnswerList(updatedAnswers))
      }
    }
  )
}

function* watchUpdateQuestionSuccess() {
  yield takeLatest(
    UPDATE_FORUM_QUESTION_SUCCESSFUL,
    function* handleUpdateQuestionSuccess({ payload }) {
      const { data } = payload

      const { source = false } = yield select(
        (state) => state.schoolReducer.questionData
      )

      yield put(closeForumModal())

      let updatedQuestions = []

      switch (source) {
        case "latest":
          const { data: latestQuestions = [] } = yield select(
            (state) => state.schoolReducer.forums
          )

          updatedQuestions = latestQuestions.map((item) => {
            if (item.id !== data.id) {
              return item
            }

            return {
              ...item,
              ...data,
            }
          })

          yield put(setForumLatestList(updatedQuestions))
          break

        case "unanswered":
          const { data: unansweredQuestions = [] } = yield select(
            (state) => state.schoolReducer.forumsUnanswered
          )

          updatedQuestions = unansweredQuestions.map((item) => {
            if (item.id !== data.id) {
              return item
            }

            return {
              ...item,
              ...data,
            }
          })

          yield put(setForumUnansweredList(updatedQuestions))
          break

        default:
          yield put(getQuestionById(data.id))
      }

      toast.success("Question updated!")
    }
  )
}

function* watchCloseQuestionSuccess() {
  yield takeLatest(
    CLOSE_FORUM_QUESTION_SUCCESSFUL,
    function* handleCloseQuestionSuccess({ payload }) {
      const { data } = payload

      const { source = false } = yield select(
        (state) => state.schoolReducer.questionData
      )

      yield put(closeConfirmModal())

      let updatedQuestions = []

      switch (source) {
        case "latest":
          const { data: latestQuestions = [] } = yield select(
            (state) => state.schoolReducer.forums
          )

          updatedQuestions = latestQuestions.map((item) => {
            if (item.id !== data.id) {
              return item
            }

            return {
              ...item,
              ...data,
            }
          })

          yield put(setForumLatestList(updatedQuestions))
          break

        case "unanswered":
          const { data: unansweredQuestions = [] } = yield select(
            (state) => state.schoolReducer.forumsUnanswered
          )

          updatedQuestions = unansweredQuestions.map((item) => {
            if (item.id !== data.id) {
              return item
            }

            return {
              ...item,
              ...data,
            }
          })

          yield put(setForumUnansweredList(updatedQuestions))
          break

        default:
          yield put(getQuestionById(data.id))
      }

      toast.success("Question closed!")
    }
  )
}

function* watchUpvoteDownvoteQuestionSuccess() {
  yield takeLatest(
    [UPVOTE_FORUM_QUESTION_SUCCESSFUL, DOWNVOTE_FORUM_QUESTION_SUCCESSFUL],
    function* handleUpvoteDownvoteQuestionSuccess({ payload, meta }) {
      const { data } = payload
      const {
        previousAction: { payload: prevPayload },
      } = meta
      const { listSource = false } = prevPayload

      let updatedQuestions = []

      switch (listSource) {
        case "latest":
          const { data: latestQuestions = [] } = yield select(
            (state) => state.schoolReducer.forums
          )

          updatedQuestions = latestQuestions.map((item) => {
            if (item.id !== data.id) {
              return item
            }

            return {
              ...item,
              ...data,
            }
          })

          yield put(setForumLatestList(updatedQuestions))
          break

        case "unanswered":
          const { data: unansweredQuestions = [] } = yield select(
            (state) => state.schoolReducer.forumsUnanswered
          )

          updatedQuestions = unansweredQuestions.map((item) => {
            if (item.id !== data.id) {
              return item
            }

            return {
              ...item,
              ...data,
            }
          })

          yield put(setForumUnansweredList(updatedQuestions))
          break

        default:
          break
      }
    }
  )
}

function* watchUpdateAnswerSuccess() {
  yield takeLatest(
    UPDATE_FORUM_ANSWER_SUCCESSFUL,
    function* handleUpdateAnswerSuccess({ payload, meta }) {
      const { data } = payload

      yield put(closeForumModal())

      const { answers = [] } = yield select(
        (state) => state.schoolReducer.questionData
      )
      const {
        previousAction: { payload: prevPayload },
      } = meta

      if (data) {
        let updatedAnswers = answers.map((item) => {
          if (item.id !== prevPayload.answerId) {
            return item
          }

          return {
            ...item,
            ...data,
          }
        })

        yield put(setForumAnswerList(updatedAnswers))
      }

      toast.success("Comment updated!")
    }
  )
}

function* watchUpdateCommentSuccess() {
  yield takeLatest(
    UPDATE_FORUM_COMMENT_SUCCESSFUL,
    function* handleUpdateCommentSuccess({ payload, meta }) {
      const { data } = payload

      yield put(closeForumModal())

      const { comments = [] } = yield select(
        (state) => state.schoolReducer.questionData
      )
      const {
        previousAction: { payload: prevPayload },
      } = meta

      if (data) {
        let updatedComments = comments.map((item) => {
          if (item.id !== prevPayload.commentId) {
            return item
          }

          return {
            ...item,
            ...data,
          }
        })

        yield put(setForumCommentList(updatedComments))
      }

      toast.success("Comment updated!")
    }
  )
}

export default [
  watchGetSchoolDataSuccess,
  watchGetSchoolDataByDomainFailed,
  watchGetSchoolForums,
  watchGetSchoolForumsUnanswered,
  watchGetSchoolForumsTag,
  watchSubmitQuestionSuccess,
  watchSubmitAnswerSuccess,
  watchSubmitCommentSuccess,
  watchFetchQuestionDataFailed,
  watchForumSubmitFailed,
  watchUpvoteDownvoteForumAnswerSuccess,
  watchUpdateQuestionSuccess,
  watchUpvoteDownvoteQuestionSuccess,
  watchUpdateAnswerSuccess,
  watchUpdateCommentSuccess,
  watchAcceptForumAnswerSuccess,
  watchCloseQuestionSuccess,
]
